import { useState } from 'react';
import { Text, Icon, TwButton as Button } from "@ui-component-library";
import { DynamicModal } from "@components/DynamicModal";
import { kycPreferences } from '../../../api/services/user';
import { KYCSkipProps } from './KYC.types';
import { useUserDataStore } from '../store/UserDataStore';

export const KYCSkip = ({ skipKYCModal, setSkipKYCModal, setOpenModal }: KYCSkipProps) => {
    const { setKyc } = useUserDataStore();
    const [isDismissing, setIsDismissing] = useState(false);

    const handleSkip = async () => {
        setIsDismissing(true);
        const response = await kycPreferences({ hasDismissedKyc: true });
        setIsDismissing(false);
        if (response.ok) {
            setOpenModal(false);
            setSkipKYCModal(false);
            setKyc({ hasDismissedKyc: true, hasCompletedKyc: false });
        } else {
            console.error('Failed to submit has dismissed kyc');
        }
    };


    return (
        <DynamicModal isOpen={skipKYCModal} onClose={() => setSkipKYCModal(false)} bp={{ sm: "drawer", lg: "dialog" }} dialogSize="medium" showDivider>
            <DynamicModal.Header>
                <>
                    <Icon name="UserCircleCheck" size="xlarge" />
                    <Button size="icon" variant="tertiary" onClick={() => setSkipKYCModal(false)} disabled={isDismissing}>
                        <Icon name="CrossSimple" />
                    </Button>
                </>
            </DynamicModal.Header>
            <DynamicModal.Content>
                <div className="flex flex-col gap-2 items-start self-stretch md:h-full md:justify-center">
                    <Text variant="text-lg/leading-normal/medium" className='my-2'>Vill du svara senare?</Text>
                    <Text variant="text-sm/leading-normal/normal">
                        Dina svar hjälper oss att anpassa upplevelsen.
                    </Text>
                    
                    <Text variant="text-sm/leading-normal/normal" className='my-2'>
                        Vi använder oss av dina svar för att:
                    </Text>
                    <div className='flex flex-col gap-8 p-4'>
                        <div className="flex">
                            <Icon name="LightbulbSimple" size="large" className="mr-3" />
                            <Text variant="text-sm/leading-normal/normal">
                                Ge personliga rekommenadationer
                            </Text>
                        </div>
                        <div className="flex">
                            <Icon name="Sliders" size="large" className="mr-3" />
                            <Text variant="text-sm/leading-normal/normal">Visa relevant innehåll</Text>
                        </div>
                    </div>
                        <Text variant="text-xs/leading-normal/normal" className="mb-2 md:text-sm mt-4">
                            Du kan använda Treebula som vanligt och svara på frågorna senare.
                        </Text>
                </div>
            </DynamicModal.Content>
            <DynamicModal.Footer>
                <Button variant="tertiary" className="w-full" onClick={() => { setOpenModal(true), setSkipKYCModal(false) }} disabled={isDismissing}>Nej, gå tillbaka</Button>
                <Button className="w-full" onClick={handleSkip} disabled={isDismissing}>
                    {isDismissing ? (
                        <div className="flex items-center justify-center gap-2">
                            <div className="h-4 w-4 animate-spin rounded-full border-2 border-solid border-white-50 border-t-transparent" />
                            <span>Hoppar över...</span>
                        </div>
                    ) : (
                        'Ja, hoppa över'
                    )}
                </Button>
            </DynamicModal.Footer>

        </DynamicModal>
    )
}